export interface BatchSchoolStatisticsRegisterNewStudentRequest {
  users: {
    studentGrade: string
    studentClass: string
    studentNumber: string
    id: string
    name: string
    nameKana: string
    birthday: string
    gender: string
  }[]
}

export function BatchSchoolStatisticsRegisterNewStudentRequestToJSON(
  value: BatchSchoolStatisticsRegisterNewStudentRequest
): any {
  return {
    users:
      value.users.length > 0
        ? value.users.map(user => ({
            student_grade:
              user.studentGrade !== '' ? user.studentGrade : undefined,
            student_class:
              user.studentClass !== '' ? user.studentClass : undefined,
            student_number:
              user.studentNumber !== '' ? user.studentNumber : undefined,
            id: user.id !== '' ? user.id : undefined,
            name: user.name !== '' ? user.name : undefined,
            name_kana: user.nameKana !== '' ? user.nameKana : undefined,
            birthday: user.birthday !== '' ? user.birthday : undefined,
            gender: user.gender !== '' ? user.gender : undefined
          }))
        : undefined
  }
}
